@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.VerticalTabs {
  @extend %font-family-primary;

  display: flex;
  flex-direction: row;
  font-size: $font-size-normal;
  height: 100%;
  min-height: 22px;

  .TabPanel {
    display: none;
    overflow: hidden;
  }

  .TabPanelSelected {
    display: block;
    flex: 1;
    overflow: auto;
  }

  .TabList {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    width: 240px;
    flex-shrink: 0;
    overflow-y: auto;
  }

  .Tab {
    box-sizing: border-box;
    color: $theme-color-text;
    display: flex;
    height: 42px;
    padding: 7px 12px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    outline: none;
    cursor: pointer;
    border: 1px solid $theme-color-borders;
    border-bottom: none;
    background: $theme-color-background;

    &:hover {
      background: $theme-dropdown-selected-background-color;
    }

    &:first-child {
      border-radius: 6px 6px 0 0;
    }

    &:last-child {
      border-radius: 0 0 6px 6px;
      border-bottom: 1px solid $theme-color-borders;
    }
  }

  .DisabledTab {
    color: $theme-color-tab-label-unselected;

    &:hover {
      color: $theme-color-tab-label-unselected;
      cursor: not-allowed;
    }
  }

  .TabSelected,
  .TabSelected:hover {
    background-color: $theme-dropdown-selected-background-color;
    color: $theme-color-text !important;
    cursor: default;
  }

  .TabPanelChildrenBase {
    display: block;
    height: 100%;
    padding-left: 16px;
  }

  .TabPanelChildrenVisible {
    display: grid;
    overflow-y: auto;
    height: 100%;
    padding-left: 16px;
  }

  .TabPanelChildrenInvisible {
    display: none;
  }

  .ExternalQueryWrapper {
    padding: 12px 16px;
  }

  .ExternalQueryTabWrapper {
    box-sizing: border-box;
    color: $theme-color-tab-label-unselected;
    display: flex;
    margin-top: auto;
  }
}
